import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDecimalNumber]'
})
export class DecimalDirective {

  @Input() beforDecimal: number;
  @Input() afterDecimal: number;


  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    let expression: RegExp;

    if (Number(this.afterDecimal) == 1) {
      expression = new RegExp(/^\d*\.?\d{0,1}$/g);
    } else if (Number(this.afterDecimal) == 2) {
      expression = new RegExp(/^\d*\.?\d{0,2}$/g);
    } else if (Number(this.afterDecimal) == 3) {
      expression = new RegExp(/^\d*\.?\d{0,3}$/g);
    } else if (Number(this.afterDecimal) == 4) {
      expression = new RegExp(/^\d*\.?\d{0,4}$/g);
    } else if (Number(this.afterDecimal) == 5) {
      expression = new RegExp(/^\d*\.?\d{0,5}$/g);
    } else if (Number(this.afterDecimal) == 6) {
      expression = new RegExp(/^\d*\.?\d{0,6}$/g);
    } else if (Number(this.afterDecimal) == 7) {
      expression = new RegExp(/^\d*\.?\d{0,7}$/g);
    } else if (Number(this.afterDecimal) == 8) {
      expression = new RegExp(/^\d*\.?\d{0,8}$/g);
    } else if (Number(this.afterDecimal) == 9) {
      expression = new RegExp(/^\d*\.?\d{0,9}$/g);
    }

    let regex: RegExp = new RegExp(expression);

  
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(e.key) !== -1 ||
      (e.keyCode === 65 && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.keyCode === 67 && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.keyCode === 86 && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.keyCode === 88 && e.ctrlKey === true) || // Allow: Ctrl+X
      (e.keyCode === 65 && e.metaKey === true) || // Cmd+A (Mac)
      (e.keyCode === 67 && e.metaKey === true) || // Cmd+C (Mac)
      (e.keyCode === 86 && e.metaKey === true) || // Cmd+V (Mac)
      (e.keyCode === 88 && e.metaKey === true) || // Cmd+X (Mac)
      (e.keyCode >= 35 && e.keyCode <= 39)) // Home, End, Left, Right
    {
      return;
    }

    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), e.key == 'Decimal' ? '.' : e.key, current.slice(position)].join('');
    if (next.length == Number(this.beforDecimal) + 1 && !next.includes('.')) {
      this.el.nativeElement.value = this.el.nativeElement.value + ".";
    }

    if (next && !String(next).match(regex)) {
      event.preventDefault();
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(e: KeyboardEvent) {
    let current: string = this.el.nativeElement.value;
    // if (current) {
    //   if (current.includes('.')) {
    //     let decimalValue = this.pad(current.split(".")[1], Number(this.afterDecimal), undefined);
    //     this.el.nativeElement.value = current.split(".")[0] + "." + decimalValue;
    //   } else {
    //     let decimalValue = this.pad(0, Number(this.afterDecimal), undefined);
    //     this.el.nativeElement.value = current.split(".")[0] + "." + decimalValue;
    //   }
    // }
  }

  pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }
}